<template>
  <md-card class="mb-card member-categories-chart">
    <md-card-header class="md-card-header-warning mb-header-fullwidth">
      <h4>
        <md-icon class="icon">bar_chart</md-icon>
        Mitgliederentwicklung
      </h4>
    </md-card-header>
    <md-card-content :key="barChartdata.labels.length">
      <BarChart
        v-if="barChartdata.labels.length && chartType === 'bar'"
        :chartdata="barChartdata"
        :options="chartoptions"
      ></BarChart>
      <LineChart
        v-if="barChartdata.labels.length && chartType === 'line'"
        :chartdata="barChartdata"
        :options="chartoptions"
      ></LineChart>
      <div v-if="loading && !barChartdata.labels.length" class="spinner">
        <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
      </div>
      <div class="time-range">
        <div class="md-layout ">
          <label class="md-layout-item md-form-label">
            Von
          </label>
          <div class="md-layout-item">
            <md-field>
              <md-select v-model="rangeStart">
                <md-option
                  :value="year"
                  :key="year"
                  v-for="year in this.rangeList"
                  >{{ year }}</md-option
                >
              </md-select>
            </md-field>
          </div>
          <label class="md-layout-item md-form-label">
            bis
          </label>
          <div class="md-layout-item">
            <md-field>
              <md-select v-model="rangeEnd">
                <md-option
                  :value="year"
                  :key="year"
                  v-for="year in this.rangeList"
                  >{{ year }}</md-option
                >
              </md-select>
            </md-field>
          </div>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>

<style scoped lang="scss">
.time-range {
  .md-layout {
    max-width: 445px;
    margin-left: auto;
  }

  .md-field {
    max-width: 140px;

    .md-select:last-of-type {
      margin-left: 10px;
    }
  }
}
.icon {
  font-size: 30px !important;
}
.mb-card .md-card-header-icon .category {
  color: #999999;
  font-size: 14px;
  padding-top: 10px;
  text-align: right;
}
.member-categories-chart {
  table {
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;

    td {
      vertical-align: top;
      padding: 0 5px;
      line-height: 1.5;
    }

    .color {
      border-radius: 100%;
      content: "";
      display: inline-block;
      width: 10px;
      height: 10px;
      background-color: currentColor;
    }
  }
}
</style>

<script>
import BarChart from "@/components/Clouseau/BarChart.vue";
import LineChart from "@/components/Clouseau/LineChart.vue";
export default {
  props: {
    load: {
      type: Boolean,
      default: true
    },
    showLegend: {
      type: Boolean,
      default: false
    },
    chartType: {
      type: String,
      default: "bar"
    }
  },
  components: {
    BarChart,
    LineChart
  },
  data() {
    return {
      loading: true,
      rangeStart: new Date().getFullYear() - 5,
      rangeEnd: new Date().getFullYear(),
      chartoptions: {
        scales: {
          xAxes: [
            {
              gridLines: {
                color: "#eeeeee",
                zeroLineColor: "#eeeeee"
              },
              stacked: this.chartType === "bar",
              ticks: {
                fontColor: "#aaa"
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                color: "#eeeeee",
                zeroLineColor: "#eeeeee"
              },
              stacked: this.chartType === "bar",
              ticks: {
                beginAtZero: true,
                fontColor: "#aaa"
              }
            }
          ]
        },
        legend: {
          display: this.showLegend
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          titleFontColor: "#000000",
          backgroundColor: "#fff",
          bodyFontColor: "#000",
          titleFontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
        }
      }
    };
  },
  created() {
    this.getData();
  },
  watch: {
    rangeStart() {
      document.body.style.overflow = "hidden";
      if (this.rangeEnd < this.rangeStart) {
        this.rangeEnd = this.rangeStart;
      }
      setTimeout(() => {
        document.body.style.overflow = null;
      }, 1000);
    },
    rangeEnd() {
      document.body.style.overflow = "hidden";
      if (this.rangeStart > this.rangeEnd) {
        this.rangeStart = this.rangeEnd;
      }
      setTimeout(() => {
        document.body.style.overflow = null;
      }, 1000);
    }
  },
  computed: {
    rangeList() {
      let years = [];
      for (let year = this.lowestYear; year <= this.currentYear; year++) {
        years.push(year);
      }
      return years;
    },
    member_categories() {
      return this.$store.getters["member_categories/list"];
    },
    statistics() {
      return this.$store.getters["statistics/list"];
    },
    lowestYear() {
      if (!this.statistics) {
        return;
      }
      let lowestYear;
      for (const statistic of this.statistics) {
        if (
          statistic.name.includes("members_category_") &&
          statistic.name.includes("_year_")
        ) {
          const year = statistic.name.substr(statistic.name.length - 4);
          if (!lowestYear || year < lowestYear) {
            lowestYear = year;
          }
        }
      }
      return lowestYear;
    },
    currentYear() {
      return new Date().getFullYear();
    },
    barChartdata() {
      const barChartdata = {
        labels: [],
        datasets: [],
        backgroundColor: []
      };
      if (
        !this.member_categories ||
        !this.member_categories.length ||
        !this.statistics ||
        !this.statistics.length
      ) {
        return barChartdata;
      }
      for (let year = this.rangeStart; year <= this.rangeEnd; year++) {
        barChartdata.labels.push(year);
      }
      for (const member_category of this.member_categories) {
        let data = [];
        let backgroundColor = [];
        let borderColor = [];
        for (let year = this.rangeStart; year <= this.rangeEnd; year++) {
          data.push(
            this.getStatsValue(
              "members_category_" + member_category.id + "_year_" + year
            )
          );
          if (this.chartType === "line") {
            borderColor.push(member_category.color);
          }
        }
        if (data.some(d => d > 0)) {
          barChartdata.datasets.push({
            fill: false,
            data,
            backgroundColor: member_category.color || "#000000",
            borderColor: member_category.color || "#000000",
            label: member_category.description
          });
        }
      }
      return barChartdata;
    }
  },
  methods: {
    getStatsValue(name) {
      if (this.statistics) {
        const statistic = this.statistics.find(s => s.name === name);
        if (!statistic) return 0;
        return statistic.value;
      }
    },
    async getData() {
      await this.$store.dispatch("member_categories/list", {
        filter: {
          ...{ "with-trashed": 1 }
        },
        page: { size: 100 }
      });
      if (this.load) {
        await this.$store.dispatch("statistics/list");
      }
      this.loading = false;
    }
  }
};
</script>
